import React from 'react'
import { Link } from 'react-router-dom'
import revixLogoAnimated from 'assets/revix-logo-animated.gif'
import imgEyesLooking from 'assets/eyes-looking.gif'
import imgEyesSpinning from 'assets/eyes-spinning.gif'

export const NotFound = () => {
    return (
        <div style={{
            backgroundColor: '#212EEE',
            color: '#FFF',
            width: '100vw',
            height: '100vh'
        }}>
            <Link to="/">
                <img src={revixLogoAnimated} style={{ width: '16rem' }} alt="revix-animated-logo"/>
                <div>
                    {
                        Math.random() > 0.75
                            ? <img alt='not-found' src={imgEyesSpinning} style={{ width: '12rem' }} />
                            : <img alt='not-found' src={imgEyesLooking} style={{ width: '12rem' }} />
                    }
                </div>
            </Link>
        </div>
    )
}